// Copyright (c) 2015, NSQUARE Technologies Pvt. Ltd. and Contributors
// MIT License. See license.txt

// provide a namespace
if (!window.froggy) window.froggy = {};

froggy.provide = function (namespace) {
	// docs: create a namespace //
	var nsl = namespace.split(".");
	var parent = window;
	for (var i = 0; i < nsl.length; i++) {
		var n = nsl[i];
		if (!parent[n]) {
			parent[n] = {};
		}
		parent = parent[n];
	}
	return parent;
};

froggy.provide("locals");
froggy.provide("froggy.flags");
froggy.provide("froggy.settings");
froggy.provide("froggy.utils");
froggy.provide("froggy.ui.form");
froggy.provide("froggy.modules");
froggy.provide("froggy.templates");
froggy.provide("froggy.test_data");
froggy.provide("froggy.utils");
froggy.provide("froggy.model");
froggy.provide("froggy.user");
froggy.provide("froggy.session");
froggy.provide("froggy._messages");
froggy.provide("locals.DocType");

// for listviews
froggy.provide("froggy.listview_settings");
froggy.provide("froggy.tour");
froggy.provide("froggy.listview_parent_route");

// constants
window.NEWLINE = "\n";
window.TAB = 9;
window.UP_ARROW = 38;
window.DOWN_ARROW = 40;

// proxy for user globals defined in desk.js

// API globals
window.cur_frm = null;
